import withPage from '@lib/page';
import HomePage from '@views/pages/home';

export default withPage(HomePage);
